import { useEffect, useRef, useState } from "react";
import { useUser } from "../../core/context/UserContext";
import ApiService from "../../core/service/ApiService";
import { Button, Dropdown, Input, Menu, Popover, Space, Table, Typography } from "antd";
import FileUtils from "../../core/utils/file-utils";
import { t } from "i18next";
import { EditOutlined } from "@ant-design/icons";
import { useModal } from "../../core/context/ModalContext";
import AppointmentFileEdit from "../appointment/AppointmentFileEdit";

export default function PatientFiles({ files, onStateChanged, appointmentId }) {
    const { user } = useUser()
    const { openModal, closeModal } = useModal()
    const fileList = useRef([])

    useEffect(() => {
        if (files) {
            fileList.current = files
        }
    }, [files])

    return (
        <>
            <Table
                size={'small'}
                pagination={false}
                dataSource={files}
                scroll={{ x: 'max-content', y: '100%' }}
                tableLayout="auto"
                style={{ flex: 1 }}
                columns={[
                    { dataIndex: 'createdDate', key: 'createdDate', title: t('Date'), render: (text) => new Date(text).toLocaleString() },
                    {
                        dataIndex: 'originalFileName',
                        key: 'originalFileName',
                        title: t('File'),
                        render: (text, row) => (
                            <div style={{ maxWidth: 250, whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                {text} {row?.isDeleted && (<Typography.Text type={'danger'}>X</Typography.Text>)}
                            </div>
                        )
                    },
                    {
                        dataIndex: 'description',
                        key: 'description',
                        title: t('Description'),
                        render: (text) => (
                            <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                                {text}
                            </div>
                        )
                    },
                    {
                        dataIndex: 'fileTypeName',
                        key: 'fileTypeName',
                        title: t('FileType'),
                        render: (text) => (
                            <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                                {text}
                            </div>
                        )
                    },
                    {
                        dataIndex: '#',
                        key: '#',
                        title: '#',
                        render: (text, row) => {
                            return (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                    <Button
                                        size={'small'}
                                        onClick={async () => {
                                            const res = await ApiService.Appointment.DownloadFile(row?.appointmentId, row.id)
                                            if (res.success) {
                                                window.open(res.data, '_blank')
                                            }
                                        }}
                                    >
                                        {t('Open')}
                                    </Button>
                                    <Button
                                        size={'small'}
                                        onClick={async () => {
                                            const fileUrl = await ApiService.Appointment.GetFileUrl(row?.appointmentId, row.id)
                                            const link = document.createElement('a');
                                            link.href = fileUrl;
                                            link.download = row.originalFileName;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }}
                                    >
                                        {t('Download')}
                                    </Button>
                                    <a
                                        style={{ marginLeft: 4 }}
                                        onClick={() => {
                                            openModal(
                                                t('File'),
                                                (<AppointmentFileEdit fileRecord={row} onSaved={() => { closeModal(); onStateChanged && onStateChanged('update') }} />),
                                                () => { }
                                            );
                                        }}
                                    >
                                        <EditOutlined />
                                    </a>
                                    {
                                        appointmentId && row?.appointmentId !== appointmentId && (
                                            <Button
                                                size={'small'}
                                                onClick={async () => {
                                                    const res = await ApiService.Appointment.AddFileToAppointment(row.id, appointmentId)
                                                }}
                                            >
                                                {t('Add To')} {': '} <b style={{ marginLeft: 4 }}>{appointmentId}</b>
                                            </Button>
                                        )
                                    }
                                </div>
                            )
                        }
                    },
                ]}
            />
        </>
    )
}